// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'users'

/**
 * User Model Interface (auto-generated from Drizzle schema)
 */
export interface UserModel {
  id: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  name: string
  email: string
  authUserId: string
  timezone?: string
  archived: boolean
  onboarded: boolean
  avatarUrl?: string
  role?: string
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "name": {
          "type": "string",
          "maxLength": 500
      },
      "email": {
          "type": "string",
          "maxLength": 200
      },
      "authUserId": {
          "type": "string",
          "maxLength": 100
      },
      "timezone": {
          "type": "string",
          "maxLength": 200
      },
      "archived": {
          "type": "boolean"
      },
      "onboarded": {
          "type": "boolean"
      },
      "avatarUrl": {
          "type": "string",
          "maxLength": 500
      },
      "role": {
          "type": "string",
          "maxLength": 50
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "createdAt",
      "updatedAt",
      "name",
      "archived",
      "onboarded",
      "email",
      "authUserId"
  ],
  indexes: [
      [
          "email",
          "createdAt"
      ],
      [
          "authUserId"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
